@if (isEditing) {
    <div class="o-grid">
        <div class="o-grid__row">
            <div class="o-grid__field">
                <mds-text-field
                    id="sponsor"
                    [formGrp]="parentFormGroup"
                    formCtrlName="sponsorControl"
                    placeholder="Type here..."
                    appearance="outline"
                    inputType="text"
                    label="Sponsor"
                    width="100%"
                    [required]="true"
                    (input)="emitStringChange($event, { id: 'sponsor' })"
                ></mds-text-field>
            </div>
        </div>
        <div class="o-grid__row">
            <div class="o-grid__field">
                <mds-text-field
                    id="protocol"
                    [formGrp]="parentFormGroup"
                    formCtrlName="protocolControl"
                    placeholder="Type here..."
                    appearance="outline"
                    inputType="text"
                    label="Protocol"
                    width="100%"
                    [required]="true"
                    (input)="emitStringChange($event, { id: 'protocol' })"
                ></mds-text-field>
            </div>
        </div>
        <div class="o-grid__row">
            <div class="o-grid__field">
                <mds-text-field
                    id="studyCode"
                    [formGrp]="parentFormGroup"
                    formCtrlName="studyCodeControl"
                    placeholder="Type here..."
                    appearance="outline"
                    inputType="text"
                    label="Project ID"
                    width="100%"
                    [required]="true"
                    (input)="emitStringChange($event, { id: 'studyCode' })"
                ></mds-text-field>
            </div>
        </div>
        @if (!isClinTrakComparison) {
            <div class="o-grid__row">
                <div class="o-grid__item">
                    <medpace-upload
                        [acceptableTypes]="acceptableFileTypes"
                        uploadButtonTitle="Upload Logo"
                        (emitStuff)="passFileAlong($event)"
                    ></medpace-upload>
                </div>
            </div>
        }
    </div>
}

@if (!isEditing && !loaderSpinner) {
    <div class="o-grid">
        <div class="o-grid__row">
            <div class="o-grid__item">
                <div class="c-info__block">
                    <h5>Sponsor</h5>
                    <span>{{ study?.sponsor }}</span>
                </div>
            </div>
        </div>
        <div class="o-grid__row">
            <div class="o-grid__item">
                <div class="c-info__block">
                    <h5>Protocol</h5>
                    <span>{{ study?.protocol }}</span>
                </div>
            </div>
        </div>
        @if (site === null) {
            <div class="o-grid__row">
                <div class="o-grid__item">
                    <div class="c-info__block">
                        <h5>Project ID</h5>
                        <span>{{ study?.studyCode }}</span>
                    </div>
                </div>
            </div>
        } @else {
            <div class="o-grid__row">
                @if (site !== null) {
                    <div class="o-grid__item">
                        <div class="c-info__block">
                            <h5>Site #</h5>
                            <span>{{ site?.info?.siteNumber }}</span>
                        </div>
                    </div>
                }
            </div>
        }
    </div>
}
@if (!isEditing && loaderSpinner) {
    <div class="o-grid">
        <medpace-loading-card></medpace-loading-card>
    </div>
}
